import { apiClient } from '~/shared/api/data-ingestion-api'

/**
 * Asks the API for a presigned CSV URL. Called imperatively rather than through
 * a query hook because the URL expires 300s after it is issued — it must be
 * requested at the moment the user clicks, never cached or prefetched.
 */
export function fetchMedistreamReport() {
  return apiClient.downloadMedistreamTrackingReportCsvMedistreamTrackingReportGet({
    throwOnError: true,
  })
}
